import { useContext, type JSX } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import {
  Chip,
  GlobalSearch,
  IconBoardwork,
  IconCommunication,
  IconDashboard,
  IconEconomy,
  IconHousing,
  IconHousingAssociation,
  IconHousingCooperative,
  IconMembership,
  IconProfile,
  IconSustainability,
} from '@bbl-digital/snorre-v2'
import useGoBackState from 'shared/hooks/useGoBackState'

export const MenuSearchHits = () => {
  const { loading, menuHits } = useContext(GlobalSearchContext)
  const { push } = useGoBackState()

  const hasMenuHits = menuHits?.hits?.length

  const searchItemIcon: Record<string, JSX.Element> = {
    economy: <IconEconomy backgrounded colorVariant="primary" />,
    boardwork: <IconBoardwork backgrounded colorVariant="primary" />,
    housing: <IconHousing backgrounded colorVariant="primary" />,
    dashboard: <IconDashboard backgrounded colorVariant="primary" />,
    communication: <IconCommunication backgrounded colorVariant="primary" />,
    'housing-association': (
      <IconHousingAssociation backgrounded colorVariant="primary" />
    ),
    housingcoop: <IconHousingCooperative backgrounded colorVariant="primary" />,
    membership: <IconMembership backgrounded colorVariant="primary" />,
    sustainability: <IconSustainability backgrounded colorVariant="primary" />,
    profile: <IconProfile backgrounded colorVariant="primary" />,
  }

  if (loading || !hasMenuHits) return null

  const Hits = () => {
    return menuHits.hits.map((item) => (
      <GlobalSearch.Item
        key={item.id}
        label={item.title}
        chip={<Chip label={item.menuGroupTitle} />}
        icon={searchItemIcon[item.menuGroupId]}
        subtitle={`Gå til ${item.title.toLowerCase()}`}
        onClick={() => push(item.route)}
      />
    ))
  }

  return (
    <GlobalSearch.Group label="Meny" title="Meny">
      <Hits />
    </GlobalSearch.Group>
  )
}
